// src/v3/logos/mifiel.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var MifielLogo = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "MifielLogo", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M11.9355 14.6869L16.1872 18.9824L20.4411 14.6891L17.6261 11.8464L27.3755 2V17.7515L15.9355 29.3067L5 17.744V2L14.7493 11.8453L11.9355 14.6869Z",
    fill: "#14D0A6"
  }
) });

export {
  MifielLogo
};
